module.exports = __webpack_public_path__ + "static/media/artem-sapegin-XGDBdSQ70O0-unsplash.18079a9b.jpg";